import { useEffect, useState } from 'react';
import { localListApi } from '../api';
import { clearWidgetCache } from './Widgets';

/**
 * "+ Mijn lijst" voor profielen zonder Plex (eigen lijst in tumedia).
 * Bij een Plex-profiel geeft de server "unknown": dan niets tonen (daar werkt de Plex-watchlist).
 */
export function LocalListButton({ type, tmdbId, imdb, title, year }: { type?: 'movie' | 'tv'; tmdbId?: number; imdb?: string; title?: string; year?: number | null }) {
  const [on, setOn] = useState<boolean | null>(null);
  const key = `${type}:${tmdbId}:${imdb}`;
  useEffect(() => {
    if (!tmdbId && !imdb) return;
    localListApi.state({ type, tmdbId, imdb }).then((r) => setOn(r.unknown ? null : r.onList)).catch(() => setOn(null));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  if (on === null) return null;
  const toggle = () => {
    const next = !on;
    setOn(next);
    localListApi.set({ type, tmdbId, imdb, title, year, on: next }).then(() => clearWidgetCache()).catch(() => setOn(!next));
  };
  return (
    <button type="button" className={`btn${on ? '' : ' btn-ghost'}`} aria-pressed={on} onClick={toggle}>
      {on ? '✓ Op mijn lijst' : '+ Mijn lijst'}
    </button>
  );
}
